module.exports = __webpack_public_path__ + "img/icon_likes_2.8d2374e2.png";